import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationTicketsListReducer} from '../../utils/types';
//actions
import {
  getTicketsList,
  getTicketsTiers,
  getTicketsStatistics,
  getTableAndTicketsAvailable,
  getTableTickets,
  updateTicketStatus,
  getPrivateTicketsTiers,
} from './actions';
//operations
import {
  pendingOperation,
  rejectedOperation,
  getTicketsListOperation,
  getTicketsTiersOperation,
  getTicketsStatisticsOperation,
  clearTablesAndTicketsDataOperation,
  getTableAndTicketsAvailableOperation,
  getTableTicketsOperation,
  clearTableTicketsOperation,
  updateStatusOperation,
  clearTicketsTiersOperation,
  getPrivateTicketsTiersOperation,
  clearPrivateTicketsTiersOperation,
} from './operations';
//constants
import {initialOrganizationData} from '@/utils/constants';

export const initialState: IOrganizationTicketsListReducer = {
  ticketsList: initialOrganizationData,
  ticketsTiers: null,
  ticketsStatistics: null,
  ticketsAvailable: initialOrganizationData,
  ticketsTable: null,
  isLoading: false,
  privateTicketsTiers: null,
};

const organizationTablesAndTicketsStore = createSlice({
  name: 'organizationTables',
  initialState,
  reducers: {
    clearTablesAndTicketsData: (state) => clearTablesAndTicketsDataOperation(state, initialState),
    clearTableTicketsData: (state) => clearTableTicketsOperation(state),
    clearTicketsTiers: (state) => clearTicketsTiersOperation(state),
    clearPrivateTicketsTiers: (state) => clearPrivateTicketsTiersOperation(state),
  },
  extraReducers: (builder) => {
    builder.addCase(getTicketsList.pending, pendingOperation);
    builder.addCase(getTicketsList.fulfilled, getTicketsListOperation);
    builder.addCase(getTicketsList.rejected, rejectedOperation);

    builder.addCase(getTicketsTiers.pending, pendingOperation);
    builder.addCase(getTicketsTiers.fulfilled, getTicketsTiersOperation);
    builder.addCase(getTicketsTiers.rejected, rejectedOperation);

    builder.addCase(getTicketsStatistics.pending, pendingOperation);
    builder.addCase(getTicketsStatistics.fulfilled, getTicketsStatisticsOperation);
    builder.addCase(getTicketsStatistics.rejected, rejectedOperation);

    builder.addCase(getTableAndTicketsAvailable.pending, pendingOperation);
    builder.addCase(getTableAndTicketsAvailable.fulfilled, getTableAndTicketsAvailableOperation);
    builder.addCase(getTableAndTicketsAvailable.rejected, rejectedOperation);

    builder.addCase(getTableTickets.pending, pendingOperation);
    builder.addCase(getTableTickets.fulfilled, getTableTicketsOperation);
    builder.addCase(getTableTickets.rejected, rejectedOperation);

    builder.addCase(updateTicketStatus.pending, pendingOperation);
    builder.addCase(updateTicketStatus.fulfilled, updateStatusOperation);
    builder.addCase(updateTicketStatus.rejected, rejectedOperation);

    builder.addCase(getPrivateTicketsTiers.pending, pendingOperation);
    builder.addCase(getPrivateTicketsTiers.fulfilled, getPrivateTicketsTiersOperation);
    builder.addCase(getPrivateTicketsTiers.rejected, rejectedOperation);
  },
});

export const {clearTablesAndTicketsData, clearTableTicketsData, clearTicketsTiers, clearPrivateTicketsTiers} =
  organizationTablesAndTicketsStore.actions;

export default organizationTablesAndTicketsStore.reducer;
